<template>
  <el-card shadow="never" class="aui-card--fill">
    <div class="mod-sys__customerpushlog0512archive}">
      <el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList()">
        <el-form-item>
          <el-input v-model="dataForm.name" placeholder="客户姓名" clearable></el-input>
        </el-form-item>
         <el-form-item>
          <el-input @change="mobileChange()" v-model="dataForm.mobile" placeholder="手机号码" clearable></el-input>
        </el-form-item>
        <el-form-item>
          <el-input v-model="dataForm.phoneMd5" placeholder="MD5" clearable></el-input>
        </el-form-item>
        <el-form-item>
          <el-select v-model="dataForm.channelId" filterable clearable placeholder="请选择渠道">
            <el-option
                    v-for="item in channels"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        
        <el-form-item>
          <el-select v-model="dataForm.pageId" filterable clearable placeholder="请选择落地页">
            <el-option
                    v-for="item in pages"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        
        <el-form-item>
          <el-date-picker
            v-model="dateValue"
            type="daterange"
            :picker-options="pickerOptions"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="getTimes"
            value-format="yyyy-MM-dd"
            align="right">
          </el-date-picker>
          <!-- <el-date-picker
                  v-model="dataForm.startDate"
                  type="date"
                  placeholder="录入开始时间"
                  value-format="yyyy-MM-dd HH:mm:ss">
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-date-picker
                  v-model="dataForm.endDate"
                  type="date"
                  placeholder="录入结束时间"
                  value-format="yyyy-MM-dd HH:mm:ss">
          </el-date-picker> -->
        </el-form-item>
        <!-- standardList -->
        <!-- <el-form-item>
          <el-select v-model="dataForm.standardCompanies" filterable  clearable placeholder="公司运营方式">
            <el-option
                    v-for="item in standardList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
            </el-option>
          </el-select>
        </el-form-item> -->

        <el-form-item>
          <el-select v-model="dataForm.companyId" filterable  clearable placeholder="所属公司">
            <el-option
                    v-for="item in cCompanys"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-select v-model="dataForm.productId" filterable clearable placeholder="产品名称">
            <el-option
                    v-for="(item,index) in productList"
                    :key="index"
                    :label="item.label"
                    :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-select v-model="dataForm.repeatStatus" filterable clearable placeholder="撞库状态">
            <el-option
                    v-for="item in statusList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-select v-model="dataForm.pushStatus" filterable clearable placeholder="推送状态">
            <el-option
                    v-for="item in statusList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        
        <!-- <el-form-item>
          <el-select v-model="dataForm.type" filterable  clearable placeholder="回访结果">
            <el-option
                    v-for="item in callTypes"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
            </el-option>
          </el-select>
        </el-form-item> -->
        
        <!-- <el-form-item>
          <el-select v-model="dataForm.isPush" filterable clearable placeholder="是否推送">
            <el-option
                    v-for="item in isPushs"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
            </el-option>
          </el-select>
        </el-form-item> -->
        <!-- <el-form-item >
              <el-select v-model="dataForm.isFixed" filterable  clearable placeholder="直投查询">
                  <el-option
                          v-for="item in isFixedList"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value">
                  </el-option>
              </el-select>
      </el-form-item> -->
      <!-- <el-form-item >
              <el-select v-model="dataForm.operationName" filterable  clearable placeholder="运营机构查询">
                  <el-option
                          v-for="(item,index) in operationsList"
                          :key="index"
                          :label="item.label"
                          :value="item.value">
                  </el-option>
              </el-select>
      </el-form-item> -->
      <el-form-item>
          <el-select v-model="dataForm.city" filterable clearable placeholder="请选择城市">
            <el-option
                    v-for="item in citys"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
            </el-option>
          </el-select>
      </el-form-item>
    <!-- <el-form-item >
    <el-select v-model="dataForm.loanType" filterable clearable placeholder="请选择贷款标识">
        <el-option
                v-for="item in loanTypes"
                :key="item.value"
                :label="item.label"
                :value="item.value">
        </el-option>
    </el-select>
    </el-form-item> -->
    <el-form-item >
    <el-select v-model="dataForm.productDockingMethod" filterable clearable placeholder="请选择产品对接方式">
        <el-option
                v-for="item in productMethodList"
                :key="item.value"
                :label="item.label"
                :value="item.value">
        </el-option>
    </el-select>
    </el-form-item>
    <el-form-item >
    <el-select v-model="dataForm.deductFlag" filterable clearable placeholder="是否计数">
        <el-option
                v-for="item in callFlagList"
                :key="item.value"
                :label="item.label"
                :value="item.value">
        </el-option>
    </el-select>
    </el-form-item>
    <el-form-item >
    <el-select v-model="dataForm.callStatus" filterable clearable placeholder="反馈状态">
        <el-option
                v-for="item in registerList"
                :key="item.value"
                :label="item.label"
                :value="item.value">
        </el-option>
    </el-select>
    </el-form-item>
        <el-form-item>
          <el-button @click="getDataList()">{{ $t('query') }}</el-button>
        </el-form-item>
        <el-form-item>
          <el-button v-if="$hasPermission('sys:customerpushlog0512archive:export')" type="info" @click="exportHandle()">{{ $t('export') }}</el-button>
        </el-form-item>
        <el-form-item>
          <el-button v-if="$hasPermission('sys:customerpushlog0512archive:save')" type="primary" @click="addOrUpdateHandle()">{{ $t('add') }}</el-button>
        </el-form-item>
        <el-form-item>
          <el-button v-if="$hasPermission('sys:customerpushlog0512archive:delete')" type="danger" @click="deleteHandle()">{{ $t('deleteBatch') }}</el-button>
        </el-form-item>
      </el-form>
      <el-table v-loading="dataListLoading" :data="dataList" border @selection-change="dataListSelectionChangeHandle" style="width: 100%;">
        <el-table-column type="selection" header-align="center" align="center" width="50"></el-table-column>
        <el-table-column prop="id" label="id" header-align="center" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column width="170" prop="pushDate" label="推送时间" header-align="center" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="name" label="客户姓名" header-align="center" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="mobile" label="手机号" header-align="center" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="phoneMd5" label="MD5" header-align="center" align="center" show-overflow-tooltip></el-table-column>
         <el-table-column prop="city" label="城市" header-align="center" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="companyName" label="公司名称" width="150" header-align="center" align="center" show-overflow-tooltip>
          <!-- <template slot-scope="scope">
            <div @click="allcompanyName($event,scope.row)" class="shou"> 
              <i class="shou-c" v-if="scope.row.myisshow !== 1" :class="scope.row.myisshow ?  'el-icon-loading' : 'el-icon-view' "></i>
              <span style=" margin-left: 10px;"  v-html="scope.row.companyName">
              </span>
            </div>
           </template> -->
        </el-table-column>
        <el-table-column prop="productName" label="产品名称" header-align="center" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="fistLevel" label="产品对接类型" header-align="center" align="center" show-overflow-tooltip>
          <template slot-scope="scope">
            {{ getDictLabel1(scope.row.fistLevel) }}
          </template>
        </el-table-column>
        <el-table-column prop="bgPush" label="平推标识" header-align="center" align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.bgPush == 1">是</span>
            <span v-if="scope.row.bgPush == 0">否</span>
          </template>
        </el-table-column>
        <el-table-column prop="productDockingMethod" label="产品对接方式" header-align="center" align="center" show-overflow-tooltip>
          <template slot-scope="scope">
            {{ getDictLabel(scope.row.productDockingMethod) }}
          </template>
        </el-table-column>
        <el-table-column prop="settlementMethod" label="产品结算方式" header-align="center" align="center" show-overflow-tooltip>
          <template slot-scope="scope">
            <div v-if="scope.row.settlementMethod == '0'">固价</div>
            <div v-if="scope.row.settlementMethod == '1'">分润前</div>
            <div v-if="scope.row.settlementMethod == '2'">分润后</div>
          </template>
        </el-table-column>
      
         <el-table-column prop="returnStatus" label="协议确认" header-align="center" align="center" >
          <template slot-scope="scope">
	           <span v-if="scope.row.returnStatus == 1">进件返</span>
             <span v-if="scope.row.returnStatus == 2">撞库返</span>
             <span v-if="scope.row.returnStatus == 3">全流程返</span>
        	</template>
        </el-table-column>
        <el-table-column prop="settlementPrice" label="产品结算价格" header-align="center" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="price" label="产品推广价格" header-align="center" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="channelPrice" label="渠道结算价格" header-align="center" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="channelPromPrice" label="渠道推广价" header-align="center" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="pageName" label="所属落地页名称" header-align="center" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="repeatPushMsg" label="撞库推送消息" header-align="center" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="repeatRespMsg" label="撞库返回消息" header-align="center" align="center" show-overflow-tooltip :tooltip-class="'custom-tooltip'"></el-table-column>
        <el-table-column prop="repeatStatus" label="撞库状态:0,成功,1:失败" header-align="center" align="center" show-overflow-tooltip>
          <template slot-scope="scope">
	            <el-tag v-if="scope.row.repeatStatus == 0" size="small">成功</el-tag>
	            <el-tag v-if="scope.row.repeatStatus == 1" type="danger" size="small">失败</el-tag>
        	</template>
        </el-table-column>
        <el-table-column prop="pushMsg" label="推送消息" header-align="center" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="respMsg" label="推送返回消息" header-align="center" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="pushStatus" label="推送状态:0,成功,1:失败" header-align="center" align="center" show-overflow-tooltip>
          <template slot-scope="scope">
	            <el-tag v-if="scope.row.pushStatus == 0" size="small">成功</el-tag>
	            <el-tag v-if="scope.row.pushStatus == 1" type="danger" size="small">失败</el-tag>
        	</template>
        </el-table-column>
        <el-table-column width="180" prop="scheduleTime" label="计划推送时间" header-align="center" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="isPush" label="是否推送(0否，1是)" header-align="center" align="center" show-overflow-tooltip>
          <template slot-scope="scope">
	            <el-tag v-if="scope.row.isPush == 1" size="small">是</el-tag>
	            <el-tag v-if="scope.row.isPush == 0" type="danger" size="small">否</el-tag>
        	</template>
        </el-table-column>
        <!-- <el-table-column prop="deduct" label="是否扣量" header-align="center" align="center" show-overflow-tooltip>
          <template slot-scope="scope">
            <el-tag v-if="scope.row.deduct == 0" type="danger" size="small">否</el-tag>
	          <el-tag v-if="scope.row.deduct == 1" size="small">是</el-tag>
          </template>
        </el-table-column> -->
        <el-table-column prop="deductFlag" label="是否计数" header-align="center" align="center" show-overflow-tooltip>
          <template slot-scope="scope">
            <el-tag v-if="scope.row.deductFlag == 0" type="danger" size="small">否</el-tag>
	          <el-tag v-if="scope.row.deductFlag == 1" size="small">是</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="pushId" label="推送ID" header-align="center" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="callStatus" label="反馈状态" header-align="center" align="center" show-overflow-tooltip>
          <template slot-scope="scope">
	            <span v-if="scope.row.callStatus == 1" >已注册</span>
              <span v-if="scope.row.callStatus == 0" >未注册</span>
        	</template>
        </el-table-column>
        <el-table-column prop="callBack" label="反馈内容" header-align="center" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="callDate" label="反馈时间" header-align="center" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="orderId" label="下游订单ID" header-align="center" align="center" show-overflow-tooltip></el-table-column>
        
        <el-table-column prop="updateBy" label="更新人" header-align="center" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="creator" label="创建人" header-align="center" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="createDate" label="创建日期" header-align="center" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="updateTime" label="更新日期" header-align="center" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column :label="$t('handle')" fixed="right" header-align="center" align="center" width="150">
          <template slot-scope="scope">
            <el-button v-if="$hasPermission('sys:customerpushlog0512archive:update')" type="text" size="small" @click="addOrUpdateHandle(scope.row.id)">{{ $t('update') }}</el-button>
            <el-button v-if="$hasPermission('sys:customerpushlog0512archive:delete')" type="text" size="small" @click="deleteHandle(scope.row.id)">{{ $t('delete') }}</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        :current-page="page"
        :page-sizes="[10, 20, 50, 100, 200, 500]"
        :page-size="limit"
        :total="total"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="pageSizeChangeHandle"
        @current-change="pageCurrentChangeHandle">
      </el-pagination>
      <!-- 弹窗, 新增 / 修改 -->
      <add-or-update v-if="addOrUpdateVisible" ref="addOrUpdate" @refreshDataList="getDataList"></add-or-update>
    </div>
  </el-card>
</template>

<script>
import mixinViewModule from '@/mixins/view-module'
import AddOrUpdate from './customerpushlog0512archive-add-or-update'
import { getOperations } from '../../../api/list'
export default {
  mixins: [mixinViewModule],
  data () {
    return {
     mixinViewModuleOptions: {
        getDataListURL: '/sys/customerpushlog0512archive/page',
        getDataListIsPage: true,
        exportURL: '/sys/customerpushlog0512archive/export',
        deleteURL: '/sys/customerpushlog0512archive',
        deleteIsBatch: true
      },
      standardList: [
        {
          value: 0,
          label: "非标准化",
        },
        {
          value: 1,
          label: "标准化",
        },
      ],
      productList:[],
      dateValue: '',
      pickerOptions: {
          shortcuts: [
          {
            text: '今天',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              // end.setTime(start.getTime() + 3600 * 1000 * 24);
              picker.$emit('pick', [start, end]);
            }
          },
            
          {
            text: '昨天',
            onClick(picker) {
              console.log(picker)
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24);
              end.setTime(end.getTime() - 3600 * 1000 * 24);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '过去七天',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          },
          {
            text: "上周",
            onClick(picker) {
              // 上周开始时间
              const starta = new Date();
              var first = starta.getDate() - starta.getDay() - 6;
              var startDate = new Date(starta.setDate(first));
              const start = new Date(startDate);
              start.setHours(0, 0, 0, 0);
              //  上周结束时间
              var currentDate = new Date();
              var firsts = currentDate.getDate() - currentDate.getDay() - 6;
              var last = firsts + 6;
              var endDate = new Date(currentDate.setDate(last));
              const end = new Date(endDate);
              end.setHours(23, 59, 59, 0);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "本周",
            onClick(picker) {
              var end = new Date();
              var week = end.getDay();
              console.log(week,'week')
              //一天的毫秒数
              var millisecond = 1000 * 60 * 60 * 24;
              //减去的天数
              var minusDay = week != 0 ? week - 1 : 6;
              
              //本周 周一
              var monday = new Date(end.getTime() - minusDay * millisecond);
              const start = new Date(monday);
              start.setHours(0, 0, 0, 0);
              console.log("2312", start, end);
              picker.$emit("pick", [start, end]);
            },

          },
       ]
        }, 
      citys:[],
      loanTypes:[],
      dataForm: {
        id: '',
        isFixed: '',
        type: '',
        standardCompanies: '',
      },
      operationsList:[],
      isFixedList:[
          {
            value: 0,
            label:'非直投'
          },
          {
            value: 1,
            label:'直投'
          }
        ],
      pages:[],
      companys:[],
      channels:[],
      productMethodList:[],
      productFirstList:[],
      callTypes:[
        // {
        //     'label':'未回访',
        //     'value':0,
        // },
        // {
        //     'label':'有效表单',
        //     'value':1,
        // }
      ],
      statusList:[
      {
            'label':'成功',
            'value':0,
        },
        {
            'label':'失败',
            'value':1,
        }
      ],
      isPushs:[
        {
            'label':'未推送',
            'value':0,
        },
        {
            'label':'已推送',
            'value':1,
        }
      ],
      registerList:[
      {
            'label':'已注册',
            'value':1,
        },
        {
            'label':'未注册',
            'value':0,
        }
      ],
      callFlagList:[
      {
            'label':'否',
            'value':0,
        },
        {
            'label':'是',
            'value':1,
        }
      ],
    }
  },
  components: {
    AddOrUpdate
  },
  async  created () {
    
    if (this.mixinViewModuleOptions.createdIsNeed) {
      // this.query()
      this.getProductList()
      this.getProductMethods();
      this.getPageOptions();
      this.getCompanysOptions();
      this.getchannelsOptions();
      this.getproductTypesFirst()
      // this.getCallTypeOptions();
      this.getCityOptions();
      // this.getLoanTypeOptions();
      this.operationsList = []
     let res = await getOperations()
     if(res.data.code == 0){
      this.operationsList = res.data.data.list.map(item => ({value:item.name,label:item.name}))
     }else{
      this.$message.error(res.data.msg)
     }
    
    }
  },
  computed: {
    mobileChange(){
      if(!this.dataForm.mobile) delete this.dataForm.mobile
  
    },
    cCompanys(){
      return  this.companys.filter(item => item.standard == this.dataForm.standardCompanies)
    }
  },
  methods: {
    getDictLabel(value) {
      const dictItem = this.productMethodList.find(item => item.value === value);
      return dictItem ? dictItem.label : ''; // 返回对应的 label 或空字符串
    },
    getDictLabel1(value) {
      const dictItem = this.productFirstList.find(item => item.value === value);
      return dictItem ? dictItem.label : ''; // 返回对应的 label 或空字符串
    },
    // 产品对接类型
    async getproductTypesFirst() {
      this.$http.get(`/sys/dict/data/list?dataType=product_first_type`).then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }

        this.productFirstList = [];
        if (res.data != null) {
          res.data.forEach(element => {
            this.productFirstList.push({ label: element.dictLabel, value: element.dictValue })
          })
        }
      }).catch(() => { })
    },
    allcompanyName(e,row){
    console.log(e)
    if(  row.myisshow === 1) return;
      

      const i = this.dataList.findIndex(item => item.id == row.id)
    
      this.$set(this.dataList,i,{...this.dataList[i],myisshow: true})
      this.$http
        .get(`/sys/customers/${row.id}`)
        .then(({ data: res }) => {
          if (res.code !== 0) {
            return this.$message.error(res.msg);
          }
          this.$set(this.dataList,i,{...this.dataList[i],myisshow: 1,companyName:  this.companys.filter(item => item.value == res.data.companyId)[0].label})
        })
        .catch(() => {});
    },
    handleReturnMsg(returnMsg){
      this.dialogVisible = true;
      this.$nextTick(() =>{
        this.returnedMessagesVal = returnMsg
      })
    },
    // 产品名称列表
    async getProductList() {
      this.$http.get(`sys/slproduct/page?order=&orderField=&page=1&limit=500`).then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        if (res.data!=null){
          res.data.list.forEach(element => {
            this.productList.push({label:element.productName,value:element.id})
          })
        }
      }).catch(() => {})
    },
    //初始化产品对接方式
    async getProductMethods() {
      this.$http.get(`/sys/dict/data/list?dataType=productDockingMethod`).then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        if (res.data!=null){
          res.data.forEach(element => {
            this.productMethodList.push({label:element.dictLabel,value:element.dictValue})
          })
        }
      }).catch(() => {})
    },
      //初始化下拉框中的选项
      async getCityOptions() {
      this.$http.get(`/sys/dict/data/list?dataType=landing_page_city`).then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.citys=[];
        if (res.data!=null){
          res.data.forEach(element => {
            this.citys.push({label:element.dictLabel,value:element.dictValue})
          })
        }
      }).catch(() => {})
    },
    //初始化落地页下拉框中的选项
    async getPageOptions() {
      this.$http.get(`/sys/landingpages/list`).then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.pages=[];
        if (res.data!=null){
          res.data.forEach(element => {
            this.pages.push({label:element.name,value:element.id})
          })
        }
      }).catch(() => {})
    },
    async getCallTypeOptions() {
          this.$http.get(`/sys/dict/data/list?dataType=return-type`).then(({ data: res }) => {
              if (res.code !== 0) {
                  return this.$message.error(res.msg)
              }
              this.callTypes=[];
              if (res.data!=null){
                  res.data.forEach(element => {
                      this.callTypes.push({label: element.dictLabel ,value: element.dictValue})
                  })
              }
          }).catch(() => {})
      },
       //初始化贷款标识下拉框中的选项
       async getLoanTypeOptions() {
          this.$http.get(`/sys/dict/data/list?dataType=loan_type`).then(({ data: res }) => {
              if (res.code !== 0) {
                  return this.$message.error(res.msg)
              }
              this.loanTypes=[];
              if (res.data!=null){
                  res.data.forEach(element => {
                      this.loanTypes.push({label:element.dictLabel,value:element.dictValue})
                  })
              }
          }).catch(() => {})
      },
    //初始化公司下拉框中的选项
    async getCompanysOptions() {
      this.$http.get(`/sys/companies/list`).then(({data: res}) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.companys = [];
        if (res.data != null) {
          res.data.forEach(element => {
            this.companys.push({label: element.name, value: element.id,standard: element.standard})
          })
        }
      }).catch(() => {
      })
    },
    //初始化渠道下拉框中的选项
    async getchannelsOptions() {
      this.$http.get(`/sys/channels/list`).then(({data: res}) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.channels = [];
        if (res.data != null) {
          res.data.forEach(element => {
            this.channels.push({label: element.name, value: element.id})
          })
        }
      }).catch(() => {
      })
    },
    
    againPush(id){
    	this.$http.get(`/sys/customers/againPush/${id}`,id).then(({ data: res }) => {
	        if (res.code !== 0) {
	          return this.$message.error(res.msg)
	        }
	        this.query();
	   }).catch(() => {})
	   
    },
    getTimes() {
        if (this.dateValue != null) {
          let startDate = new Date(this.dateValue[0])
          let year = startDate.getFullYear();
          let month = String(startDate.getMonth() + 1).padStart(2, '0');
          let day = String(startDate.getDate()).padStart(2, '0');

          let endDate = new Date(this.dateValue[1])
          let e_year = endDate.getFullYear();
          let e_month = String(endDate.getMonth() + 1).padStart(2, '0');
          let e_day = String(endDate.getDate()).padStart(2, '0');
          
          this.dataForm.startDate =  `${year}-${month}-${day} 00:00:00`
          this.dataForm.endDate = `${e_year}-${e_month}-${e_day} 23:59:59`
        }else{
          delete this.dataForm.startDate 
          delete this.dataForm.endDate
        }
      },
  }
}
</script>
<style>
.shou {
  cursor: pointer;
   display: flex;
  justify-content: center;
  align-items: center;
}
.shou-c{
  width: 12px;
  height: 12px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.custom-tooltip {
  width: 200px;
  background-color: rgba(216, 17, 17, 0.8); /* 背景颜色 */
  color: #fff; /* 字体颜色 */
  border-radius: 4px; /* 圆角 */
  padding: 10px; /* 内边距 */
  font-size: 14px; /* 字体大小 */
  max-width: 300px; /* 最大宽度 */
  word-wrap: break-word; /* 自动换行 */
}
</style>

